<template>
    <div class="c-header-search" id="c-header-search">
        <div class="c-search">
            <form class="u-form" @submit.prevent="handleSubmit">
                <input class="u-text" type="text" autocomplete="off" name="q" placeholder="搜索.." ref="searchInput" />
                <input type="hidden" name="client" :value="client" />
                <i class="u-btn" @click="handleSubmit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" stroke="#979A9C" opacity=".4" d="M3.5.5h12c1.7 0 3 1.3 3 3v13c0 1.7-1.3 3-3 3h-12c-1.7 0-3-1.3-3-3v-13c0-1.7 1.3-3 3-3z"/><path fill="#979A9C" d="M11.8 6L8 15.1h-.9L10.8 6h1z"/></svg>
                </i>
            </form>
        </div>
    </div>
</template>

<script>
import { __Root } from "@jx3box/jx3box-common/data/jx3box.json";
import {searchJump} from "../../assets/js/utils";
export default {
    name: "search",
    data: function () {
        return {
            isPhone: window.innerWidth < 720 ? true : false,
            url: __Root + "search",
            client: location.href.includes("origin") ? "origin" : "std",
        };
    },
    computed: {},
    methods: {
        handleSubmit() {
            // 获取输入框的值
            const searchValue = this.$refs.searchInput.value;
            if (!searchValue) return;

            searchJump({
                searchValue: searchValue,
                isPhone: this.isPhone,
                url: this.url,
                client: this.client,
            });
        },
    },
    created: function () {},
    components: {},
};
</script>

<style lang="less">
//搜索
.c-header-search {
    width: 220px;
    // padding: 16px 0;
    margin: (@header-height - @logo-size - 2px)/2 0;

    .u-form {
        position: relative;
    }

    .u-text {
        background-color: #3a4248;
        border: 2px solid @bg-black;
        // background-color:#636872;
        // border: 0;
        box-shadow: none;
        color: #fff;
        height: @logo-size + 2px;
        line-height: @logo-size + 2px;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 14px;
        padding: 0.625em 0.4375em;
        width: 100%;

        &:focus {
            background-color: #fff;
            color: #1a1a1a;
            outline: 0;
        }
        transition: background-color 0.1s ease-in;
    }

    .u-btn {
        border: 0;
        position: absolute;
        right: 8px;
        top: 6px;
        display: block;
        width: 19px;
        height: 20px;
        padding: 0;
    }

    margin-right: 10px;
}
@media screen and (max-width: @phone) {
    .c-header-search {
        .none;
    }
}
</style>
